import { useAuth } from '@/context/AuthContext';
import UserAvatarSVG from '@/components/UserAvatarSVG';

const HomePage = () => {
    const { user } = useAuth();
    return (
        <>
            <div>
                <h1 className="dashboard-greeting">
                    <UserAvatarSVG />
                    Hello {user?.FirstName || user?.firstName}
                </h1>
            </div>
            <div className="main-content" style={{ margin: '10% auto 0px auto', alignItems: 'center', justifyContent: 'center' }}>
                <div className="dashboard-card" style={{ padding: 40, borderRadius: 16, boxShadow: '0 2px 16px rgba(246,48,64,0.08)', background: '#fff', textAlign: 'center' }}>
                    <div style={{ marginBottom: 24 }}>
                        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="32" cy="32" r="32" fill="#F63040" />
                            <path d="M20 36h24v2a8 8 0 01-8 8H28a8 8 0 01-8-8v-2z" fill="#fff"/>
                            <circle cx="32" cy="28" r="8" fill="#fff" />
                            <ellipse cx="32" cy="44" rx="14" ry="8" fill="#fff" fillOpacity="0.5" />
                        </svg>
                    </div>
                    <h1 className="section-title" style={{ color: '#F63040', marginBottom: 12 }}>Coming Soon</h1>
                    <p style={{ color: '#57565B', fontSize: 18, marginBottom: 0 }}>
                        We're working hard to bring you something amazing.<br />
                        Watch this space for more to come!
                    </p>
                </div>
            </div>
        </>
    );
}

export default HomePage;